const icon = {
    url: `${process.env.PUBLIC_URL}/images/marker_red_red_dot.png`,
    anchor: new window.google.maps.Point(12, 28)
};

export default icon;
